/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighboursFiles } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const FilesCommunities = ({ getNeighboursFiles, communityFiles, period }) => {
  useEffect(() => {
    getNeighboursFiles({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursFiles(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursFiles(payload);
  };

  return (
    <DataTable
      preset="filesCommunities"
      data={{
        docs: communityFiles?.docs || [],
        totalPages: communityFiles?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityFiles: state.appCommunities.communityFiles,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighboursFiles: (payload) => dispatch(getNeighboursFiles(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilesCommunities);